import { get } from "lodash"
import { createSelector } from "reselect"
import { getAllAvailableRollups, getQueryGroupBy } from "helpers/rollups"
import { getGroupingLabel } from "helpers/assets"
import { getIsActive, getViewType } from "modules/portfolio-root/selectors/portfolios"
import { getTagCategories, getAttributeCategories } from "modules/portfolio-root/selectors"
import { getRebalanceDate } from "."

const getGroupingRaw = state => get(state, "modules.rebalance.grouping")
const getClassifications = (state) => get(state, "global.data.classifications.data.classifications")
const getRawSelectedGroup = state => get(state, "modules.rebalance.selectedGroup")

export const getGrouping = createSelector(
  [getGroupingRaw, getIsActive],
  (grouping, isActive) => grouping ? { ...grouping, label: getGroupingLabel(grouping, isActive) } : null,
)

export const getSelectedGroup = createSelector(
  [getRawSelectedGroup, getGrouping],
  (selectedGroup, grouping) => !grouping ? null : selectedGroup,
)

const getAccountRollups = createSelector(
  [getClassifications, getTagCategories, getAttributeCategories],
  (classifications, tagCategories, attributeCategories) => ({
    classifications,
    tagCategories,
    attributeCategories,
  }),
)

export const getAvailableRollups = createSelector(
  [getAccountRollups, getRebalanceDate, getViewType],
  getAllAvailableRollups,
)

export const getGroupingOptions = createSelector(
  [getGrouping, getIsActive],
  getQueryGroupBy,
)
